document.addEventListener('DOMContentLoaded', function () {
  function getPrimaryOptionSelect() {
    return document.querySelector(
      'select[name="options[Size]"], select[name="options[Select your colourway]"]'
    );
  }

  function getAllDropdownWrappers() {
    return Array.from(document.querySelectorAll('.product-form__input--dropdown'));
  }

  function getSecondaryOptionWrappers() {
    const primarySelect = getPrimaryOptionSelect();
    if (!primarySelect) return [];

    return getAllDropdownWrappers().filter(function (wrapper) {
      return !wrapper.contains(primarySelect);
    });
  }

  function getBespokeSelect() {
    const secondaryWrappers = getSecondaryOptionWrappers();

    for (const wrapper of secondaryWrappers) {
      const label = wrapper.querySelector('label');
      const select = wrapper.querySelector('select');

      if (!select) continue;

      const labelText = (label ? label.textContent : '').trim().toLowerCase();
      const firstOption = select.querySelector('option');
      const firstOptionText = firstOption ? firstOption.textContent.trim().toLowerCase() : '';

      if (
        labelText.includes('bespoke quantity') ||
        firstOptionText.includes('bespoke quantity')
      ) {
        return select;
      }
    }

    return secondaryWrappers
      .map(function (wrapper) {
        return wrapper.querySelector('select');
      })
      .find(Boolean);
  }

  function getQuantityBlock() {
    return document.querySelector('.price-per-item__container');
  }

  function getQuantityInput() {
    return document.querySelector('input[name="quantity"]');
  }

  function getInfiniteOptionsBlock() {
    return document.querySelector('#infiniteoptions-container');
  }

  function getAddToCartButton() {
    return document.querySelector('button[name="add"]');
  }

  function getProductForm() {
    const addButton = getAddToCartButton();
    return addButton ? addButton.closest('form') : null;
  }

  function setQuantityMin(quantityInput, minValue) {
    quantityInput.min = String(minValue);
    quantityInput.setAttribute('min', String(minValue));
    quantityInput.dataset.min = String(minValue);
    quantityInput.setAttribute('data-min', String(minValue));
  }

  function showMinQtyMessage(message) {
    const quantityBlock = getQuantityBlock();
    if (!quantityBlock) return;

    let popup = quantityBlock.querySelector('.bespoke-min-qty-message');

    if (!popup) {
      popup = document.createElement('div');
      popup.className = 'bespoke-min-qty-message';
      quantityBlock.appendChild(popup);
    }

    popup.textContent = message;
    popup.classList.add('is-visible');

    clearTimeout(popup._hideTimer);
    popup._hideTimer = setTimeout(function () {
      popup.classList.remove('is-visible');
    }, 2200);
  }

  function isBespokeActive() {
    const bespokeSelect = getBespokeSelect();
    if (!bespokeSelect) return false;

    const firstOption = bespokeSelect.querySelector('option');
    const placeholderValue = firstOption ? firstOption.value : '';

    return bespokeSelect.value === placeholderValue;
  }

  function getBespokeMinQty() {
    const quantityBlock = getQuantityBlock();
    if (!quantityBlock) return 1;

    return parseInt(quantityBlock.dataset.bespokeMinQty || '1', 10);
  }

  function hasPrimaryVariantChoice() {
    const primarySelect = getPrimaryOptionSelect();
    if (!primarySelect) return true;
    return primarySelect.value !== '';
  }

  function getVisibleRequiredFields() {
    const container = getInfiniteOptionsBlock();
    if (!container) return [];

    return Array.from(
      container.querySelectorAll('input[required], textarea[required], select[required]')
    ).filter(function (field) {
      if (field.disabled) return false;
      if (field.type === 'hidden') return false;
      return field.offsetParent !== null;
    });
  }

  function areRequiredFieldsValid() {
    const fields = getVisibleRequiredFields();
    if (!fields.length) return false;

    return fields.every(function (field) {
      if ((field.type === 'checkbox' || field.type === 'radio')) {
        return field.checked;
      }
      if (field.tagName === 'SELECT') {
        return String(field.value || '').trim() !== '';
      }
      return String(field.value || '').trim() !== '';
    });
  }

  function updateRequiredAttributes() {
    const container = getInfiniteOptionsBlock();
    if (!container) return;

    const shouldRequire = hasPrimaryVariantChoice();

    container.querySelectorAll('input, textarea, select').forEach(function (field) {
      const name = (field.name || '').toLowerCase();
      const id = (field.id || '').toLowerCase();
      const placeholder = (field.placeholder || '').toLowerCase();

      const isDeliveryField =
        id.includes('delivery') ||
        id.includes('date') ||
        name.includes('delivery') ||
        name.includes('date') ||
        placeholder.includes('delivery') ||
        placeholder.includes('date');

      const isCardMessageField =
        id.includes('card') ||
        id.includes('message') ||
        name.includes('card') ||
        name.includes('message') ||
        placeholder.includes('card') ||
        placeholder.includes('message');

      if (isDeliveryField || isCardMessageField) {
        if (shouldRequire) {
          field.setAttribute('required', 'required');
          field.setAttribute('aria-required', 'true');
        } else {
          field.removeAttribute('required');
          field.removeAttribute('aria-required');
        }
      }
    });
  }

  function updateAddToCartState() {
    const addButton = getAddToCartButton();
    if (!addButton) return;

    const shouldEnable = hasPrimaryVariantChoice() && areRequiredFieldsValid();

    addButton.disabled = !shouldEnable;
    addButton.setAttribute('aria-disabled', String(!shouldEnable));
    addButton.classList.toggle('is-disabled-by-custom-js', !shouldEnable);
  }

  function toggleProductActionsVisibility() {
    const hasPrimaryOption = hasPrimaryVariantChoice();

    const priceBlock = document.querySelector('#price-template--26407413907837__main, .price-hidden-until-size');
    const infiniteOptionsBlock = getInfiniteOptionsBlock();
    const quantityBlock = getQuantityBlock();
    const secondaryOptionWrappers = getSecondaryOptionWrappers();

    if (priceBlock) {
      priceBlock.classList.toggle('price-hidden-until-size', !hasPrimaryOption);
    }

    if (infiniteOptionsBlock) {
      infiniteOptionsBlock.classList.toggle('hidden-until-size', !hasPrimaryOption);
    }

    if (quantityBlock) {
      quantityBlock.classList.toggle('hidden-until-size', !hasPrimaryOption);
    }

    secondaryOptionWrappers.forEach(function (wrapper) {
      wrapper.classList.toggle('hidden-until-size', !hasPrimaryOption);
    });
  }

  function enforceBespokeMinimum() {
    const quantityInput = getQuantityInput();
    const bespokeSelect = getBespokeSelect();

    if (!quantityInput || !bespokeSelect) return;

    const minQty = getBespokeMinQty();
    const fallbackMin = 1;

    const firstOption = bespokeSelect.querySelector('option');
    const placeholderValue = firstOption ? firstOption.value : '';
    const isBespoke = bespokeSelect.value === placeholderValue;

    if (isBespoke) {
      setQuantityMin(quantityInput, minQty);

      const currentQty = parseInt(quantityInput.value || '1', 10);
      if (isNaN(currentQty) || currentQty < minQty) {
        quantityInput.value = String(minQty);
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    } else {
      setQuantityMin(quantityInput, fallbackMin);

      const currentQty = parseInt(quantityInput.value || '1', 10);
      if (isNaN(currentQty) || currentQty < fallbackMin) {
        quantityInput.value = String(fallbackMin);
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  }

  function handleMinusClick(event) {
    const minusButton = event.target.closest('.quantity__button[name="minus"]');
    if (!minusButton) return;

    const quantityInput = getQuantityInput();
    if (!quantityInput) return;

    if (!isBespokeActive()) return;

    const minQty = getBespokeMinQty();
    const currentQty = parseInt(quantityInput.value || '1', 10);

    if (currentQty <= minQty) {
      event.preventDefault();
      showMinQtyMessage('Minimum bespoke quantity is ' + minQty + '.');
    }
  }

  function focusFirstInvalidField() {
    const fields = getVisibleRequiredFields();

    const firstInvalidField = fields.find(function (field) {
      if ((field.type === 'checkbox' || field.type === 'radio')) {
        return !field.checked;
      }
      return String(field.value || '').trim() === '';
    });

    if (firstInvalidField) {
      firstInvalidField.focus();
    }
  }

  function runAll() {
    toggleProductActionsVisibility();
    updateRequiredAttributes();
    enforceBespokeMinimum();
    updateAddToCartState();
  }

  const addButton = getAddToCartButton();
  if (addButton) {
    addButton.disabled = true;
    addButton.setAttribute('aria-disabled', 'true');
  }

  runAll();

  document.addEventListener('click', handleMinusClick);

  document.addEventListener('change', function (event) {
    if (
      event.target.matches('select[name="options[Size]"]') ||
      event.target.matches('select[name="options[Select your colourway]"]') ||
      event.target.closest('.product-form__input--dropdown') ||
      event.target.closest('#infiniteoptions-container') ||
      event.target.matches('input[name="quantity"]')
    ) {
      setTimeout(runAll, 0);
    }
  });

  document.addEventListener('input', function (event) {
    if (
      event.target.closest('#infiniteoptions-container') ||
      event.target.matches('input[name="quantity"]')
    ) {
      setTimeout(runAll, 0);
    }
  });

  const form = getProductForm();
  if (form) {
    form.addEventListener(
      'submit',
      function (event) {
        runAll();

        const valid = hasPrimaryVariantChoice() && areRequiredFieldsValid();

        if (!valid) {
          event.preventDefault();
          event.stopPropagation();
          focusFirstInvalidField();
        }
      },
      true
    );
  }

  const target = document.querySelector('main') || document.body;

  const observer = new MutationObserver(function () {
    runAll();
  });

  observer.observe(target, {
    childList: true,
    subtree: true
  });
});


// -----------------------------
// SHOP Menu Text
// -----------------------------

document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.header-bar--left');
  if (!container) return;

  const shopLink = document.createElement('a');
  shopLink.href = '/collections/luxury-flowers-london';
  shopLink.className = 'header-shop-link';
  shopLink.textContent = 'SHOP';

  container.appendChild(shopLink);
});


// -----------------------------
// Header hide on scroll
// -----------------------------

document.addEventListener('DOMContentLoaded', function () {
  const header = document.getElementById('SiteHeader');
  if (!header) return;

  const hasTransparentHomeHeader = header.classList.contains('hdr-trans-hp');

  let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const scrollTolerance = 2;

  function updateHeaderState() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const headerHeight = header.offsetHeight;

    const atTop = scrollTop <= 0;
    const scrollingUp = scrollTop < (lastScrollTop - scrollTolerance);
    const scrollingDown = scrollTop > (lastScrollTop + scrollTolerance);

    const scrollAwayOffset = Math.min(scrollTop, headerHeight);

    const wasWhiteVisible = header.classList.contains('header-white-visible');
    const wasWhiteHidden = header.classList.contains('header-white-hidden');
    const wasTransparentHome = header.classList.contains('hdr-trans-hp');

    header.classList.remove(
      'header-transparent-scrollaway',
      'header-standard-scrollaway',
      'header-home-white',
      'header-standard-white',
      'header-white-visible',
      'header-white-hidden',
      'is-scrolling-up',
      'is-scrolling-down'
    );

    if (hasTransparentHomeHeader) {
      header.style.setProperty('--header-scroll-offset', scrollAwayOffset + 'px');

      if (atTop) {
        header.classList.add('hdr-trans-hp', 'header-transparent-scrollaway');
        header.style.setProperty('--header-scroll-offset', '0px');
      } else if (scrollingDown) {
        header.classList.add('hdr-trans-hp', 'header-transparent-scrollaway', 'is-scrolling-down');
      } else if (scrollingUp) {
        header.classList.remove('hdr-trans-hp');
        header.classList.add('header-home-white', 'header-white-visible', 'is-scrolling-up');
        header.style.setProperty('--header-scroll-offset', '0px');
      } else {
        if (wasWhiteVisible || wasWhiteHidden) {
          header.classList.add('header-home-white', 'header-white-visible');
          header.style.setProperty('--header-scroll-offset', '0px');
        } else if (wasTransparentHome) {
          header.classList.add('hdr-trans-hp', 'header-transparent-scrollaway');
        } else {
          header.classList.add('header-home-white');
          header.style.setProperty('--header-scroll-offset', '0px');
        }
      }
    } else {
      header.style.setProperty('--header-scroll-offset', scrollAwayOffset + 'px');

      if (atTop) {
        header.classList.add('header-standard-scrollaway');
        header.style.setProperty('--header-scroll-offset', '0px');
      } else if (scrollingDown) {
        header.classList.add('header-standard-scrollaway', 'is-scrolling-down');
      } else if (scrollingUp) {
        header.classList.add('header-standard-white', 'header-white-visible', 'is-scrolling-up');
        header.style.setProperty('--header-scroll-offset', '0px');
      } else {
        if (wasWhiteVisible || wasWhiteHidden) {
          header.classList.add('header-standard-white', 'header-white-visible');
          header.style.setProperty('--header-scroll-offset', '0px');
        } else {
          header.classList.add('header-standard-scrollaway');
        }
      }
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }

  updateHeaderState();
  window.addEventListener('scroll', updateHeaderState, { passive: true });
  window.addEventListener('resize', updateHeaderState);
});


// -----------------------------
// SHUFFLE COLLECTION PAGE + DOUBLE WIDTH VIDEOS
// -----------------------------

document.addEventListener('DOMContentLoaded', () => {
  function syncDoubleWidthCollectionVideos() {
    const grid = document.querySelector('#product-grid');
    if (!grid) return;

    const videos = grid.querySelectorAll('.collection-card-video');

    videos.forEach((video) => {
      const item = video.closest('.grid__item');
      if (!item) return;

      const isDoubleWidth = item.classList.contains('grid__item_double_width');

      if (!video.dataset.initialised) {
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;

        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('loop', '');
        video.removeAttribute('controls');

        video.dataset.initialised = 'true';
      }

      if (isDoubleWidth) {
        if (video.paused) {
          const playPromise = video.play();

          if (playPromise && typeof playPromise.then === 'function') {
            playPromise
              .then(() => {
                item.classList.add('video-ready');
              })
              .catch(() => {
                item.classList.remove('video-ready');
              });
          }
        }
      } else {
        if (!video.paused) {
          video.pause();
        }

        item.classList.remove('video-ready');

        try {
          video.currentTime = 0;
        } catch (e) {}
      }
    });
  }

  function shuffleCollectionGrid() {
    const grid = document.querySelector('#product-grid.collection-creative-layout');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll(':scope > .grid__item'))
      .filter((item) => item.querySelector('.card-product'));

    if (!items.length) return;

    items.forEach((item) => {
      item.classList.remove('grid__item_double_width');
      item.classList.remove('video-ready');
    });

    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }

    items.forEach((item) => grid.appendChild(item));

    const eligiblePositions = [0, 5, 10, 15, 20, 25].filter((i) => i < items.length);

    for (let i = eligiblePositions.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [eligiblePositions[i], eligiblePositions[j]] = [eligiblePositions[j], eligiblePositions[i]];
    }

    const doubleWidthCount = Math.min(3, eligiblePositions.length);

    for (let i = 0; i < doubleWidthCount; i++) {
      items[eligiblePositions[i]].classList.add('grid__item_double_width');
    }

    syncDoubleWidthCollectionVideos();
  }

  shuffleCollectionGrid();

  document.addEventListener('shopify:section:load', () => {
    shuffleCollectionGrid();
  });

  window.addEventListener('load', () => {
    syncDoubleWidthCollectionVideos();
  });
});


// -----------------------------
// £0.00 to POA
// -----------------------------

document.addEventListener('DOMContentLoaded', function () {
  const poaPath = '/products/stairway';

  function getSelectedVariantPrice() {
    const script = document.querySelector('script[type="application/json"][data-selected-variant]');
    if (!script) return null;

    try {
      const variant = JSON.parse(script.textContent);
      return typeof variant.price !== 'undefined' ? Number(variant.price) : null;
    } catch (e) {
      return null;
    }
  }

  function replaceZeroPricesWithPOA(scope) {
    scope.querySelectorAll('.price-item--regular, .price-item--sale').forEach(function (el) {
      const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (text === '£0.00' || text === '£0') {
        el.textContent = 'POA';
        el.style.textTransform = 'uppercase';
      }
    });
  }

  function updateProductPOA() {
    if (window.location.pathname !== poaPath) return;

    const price = getSelectedVariantPrice();
    const isPOA = price === 0;

    replaceZeroPricesWithPOA(document);

    const qtyForm = document.querySelector('#Quantity-Form-template--26407413907837__main');
    const appBlock = document.querySelector('.product-app-block');
    const buyButtonsWrap = document.querySelector('.product-buy-buttons-wrapper');

    if (qtyForm) qtyForm.style.display = isPOA ? 'none' : '';
    if (appBlock) appBlock.style.display = isPOA ? 'none' : '';
    if (buyButtonsWrap) buyButtonsWrap.style.display = isPOA ? 'none' : '';
  }

  function updateCollectionPOA() {
    document.querySelectorAll('a[href="' + poaPath + '"]').forEach(function (link) {
      const card = link.closest('.card-wrapper, .card, .grid__item, .product-card');
      if (!card) return;
      replaceZeroPricesWithPOA(card);
    });
  }

  function runPOA() {
    updateProductPOA();
    updateCollectionPOA();
  }

  runPOA();

  document.addEventListener('change', function (e) {
    if (window.location.pathname === poaPath && e.target.closest('variant-selects, form[action*="/cart/add"]')) {
      setTimeout(runPOA, 50);
      setTimeout(runPOA, 200);
    }
  });

  document.addEventListener('click', function (e) {
    if (window.location.pathname === poaPath && e.target.closest('variant-selects')) {
      setTimeout(runPOA, 50);
      setTimeout(runPOA, 200);
    }
  });

  setTimeout(runPOA, 300);
  setTimeout(runPOA, 800);
});

document.addEventListener('DOMContentLoaded', function () {
  const LOCK_CLASS = 'is-sliding';

  document.addEventListener('click', function (event) {
    const arrow = event.target.closest('.product-card-pagination-arrow');
    if (!arrow) return;

    const container = arrow.closest('.card-product--image-swipe-container');
    if (!container) return;

    if (container.classList.contains(LOCK_CLASS)) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    container.classList.add(LOCK_CLASS);

    setTimeout(() => {
      container.classList.remove(LOCK_CLASS);
    }, 350);
  }, true);
});